import { Button } from "@chakra-ui/react";
import { AlertsContext } from "providers/alerts";
import { useContext, useState } from "react";
import { apiRequest } from "utils/api";
import { getErrorMessage } from "utils/errorHandler";
import { useCurrentUserQuery } from "modules/tenant/queries/use-current-user-query";

const RefreshBalancesButton = () => {
  const { refetch } = useCurrentUserQuery();

  const { showError, showSuccess } = useContext(AlertsContext);

  const [refreshing, setRefreshing] = useState(false);

  async function refreshBalances() {
    try {
      setRefreshing(true);
      await apiRequest("/plaid/getBalances");
      await refetch();
      showSuccess({
        title: "Balances Refreshed",
        description: "The bank account balances have been successfully refreshed.",
      });
    } catch (err) {
      showError({
        title: "Refresh Failed",
        descrption: getErrorMessage(err),
      });
    } finally {
      setRefreshing(false);
    }
  }

  return (
    <Button isLoading={refreshing} variant="secondary" onClick={refreshBalances} w="100%" mb="8px">
      Refresh Balances
    </Button>
  );
};

export default RefreshBalancesButton;
